import React from 'react';
import PropTypes from 'prop-types';
import YellowGreenButton from './YellowGreenButton';
import i18n from '../utils/i18n';

import './styles/DeucePremiumComponent.scss';

const DeucePremiumComponent = ({ routeToSubscription }) => (
  <div className="deuce-premium-component">
    <div className="deuce-premium-content">
      <div className="heading">
        {i18n.t('deucePremium.DEUCE_PREMIUM')}
      </div>
      <div className="price">
        <span className="amount">
          {i18n.t('deucePremium.PRICE')}
        </span>
        /
        <span className="month">
          {i18n.t('deucePremium.PERIOD')}
        </span>
      </div>
      <div className="free-month">
        {i18n.t('deucePremium.FIRST_MONTH_FOR_FREE')}
      </div>
      <div className="cancel-anytime">
        {i18n.t('deucePremium.CANCEL_ANYTIME')}
      </div>
    </div>

    <hr />
    <div className="deuce-premium-content">
      <ul>
        <li>
          {i18n.t('deucePremium.FREE_COURT')}
        </li>
        <li>
          {i18n.t('deucePremium.FREE_SESSION')}
        </li>
      </ul>
    </div>
    <div className="button-container">
      <YellowGreenButton
        text={ i18n.t('deucePremium.START_FREE_TRIAL') }
        onClick={ routeToSubscription }
      />
    </div>
  </div>
);

DeucePremiumComponent.propTypes = {
  routeToSubscription: PropTypes.func
};

DeucePremiumComponent.defaultProps = {
  routeToSubscription: () => {}
};

export default DeucePremiumComponent;



// WEBPACK FOOTER //
// ./src/components/DeucePremiumComponent.js